import { useState, useEffect } from "react"
function useInputBlocking (roleName, userRole)  {
    const [lockState, setLockState] = useState(false)

    useEffect(() => {
        const isHighPrivPatient = roleName === 'ИТ-админ' || roleName === 'Супер-админ';
        const isAdminUser = userRole === 'Administrator';

        const blocking = userRole !== 'Super-admin' && (isHighPrivPatient && isAdminUser);
        setLockState(blocking);
        
    },[roleName, userRole])

    return lockState;
}

export default useInputBlocking